import React, { useState, useContext } from "react";
import { GreenMachineContext } from "../GreenMachineContext";
import { graphql, QueryRenderer } from "react-relay";
import environment from "../../../../../RelayEnvironment";
import PlayerTable from "../PlayerTable";
import { commitMutation } from "react-relay";
import relayEnvironment from "../../../../../RelayEnvironment";
import { COMMIT_PLAYER_CHANGES } from "./mutations/CommitPlayerExposureChanges";
import ExposuresTable from "./ExposuresTable";
import "./SelectExposures.css";

const GET_PLAYERS = graphql`
  query SelectExposuresQuery($gmID: ID!) {
    playersForGreenMachineSession(greenMachineSessionId: $gmID) {
      id
      exposure
      slatePlayer {
        id
        player {
          id
          name
          shortenedName
          team {
            abbreviation
            name
          }
        }
        position
        fppg
        salary
        rosterSlots {
          edges {
            node {
              name
            }
          }
        }
        slateCompetition {
          prettyStartTime
        }

        gupPercProj
        projPoints
        suffix
      }
    }

    greenMachineSession(id: $gmID) {
      id
      user {
        username
      }

      slate {
        prettyStartTime
      }

      selectedPlayerIds
      numLineups
    }
  }
`;

export default function SelectExposures() {
  const {
    greenMachineSessionID,
    selectedSlateID,
    currentStage,
    STAGE_NUMBERS,
  } = useContext(GreenMachineContext);

  const STAGE_NUMBER = STAGE_NUMBERS.selectExposures;

  if (currentStage < STAGE_NUMBER) {
    return null;
  }

  if (currentStage > STAGE_NUMBER) {
    return null;
  }

  return (
    <QueryRenderer
      environment={environment}
      query={GET_PLAYERS}
      variables={{
        slateID: selectedSlateID,
        gmID: greenMachineSessionID,
      }}
      render={({ error, props }) => {
        if (error) {
          return <div>Something went wrong.</div>;
        }

        if (!props) {
          return (
            <div className="gm-player-exposure-container">
              Loading exposures...
            </div>
          );
        }

        return (
          <div className="gm-player-exposure-container">
            <ExposuresTable
              players={props.playersForGreenMachineSession}
              numLineups={props.greenMachineSession.numLineups}
            />
          </div>
        );
      }}
    />
  );
}
